import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle, IconButton } from '@mui/material';
import React, { FC, ReactElement } from 'react';
import Markdown from 'react-markdown';

const MUIAlert: FC<{
	infoType?: 'success' | 'info' | 'warning' | 'error';
	title?: string;
	message: string | ReactElement;
	onClose?: () => void;
	showCloseButton?: boolean;
}> = ({ infoType = 'info', title, message, onClose, showCloseButton = false }) => {
	const RenderMessage = () => {
		if (typeof message === 'string') {
			return <Markdown components={{ p: 'div' }}>{message}</Markdown>;
		} else {
			return <>{message}</>;
		}
	};

	if (!message && !title) {
		return <></>;
	}
	return (
		<Alert
			severity={infoType}
			action={
				showCloseButton ?
					<>
						<IconButton aria-label='close' color='inherit' size='small' onClick={onClose}>
							<CloseIcon />
						</IconButton>
					</>
				:	null
			}
		>
			{title && <AlertTitle>{title}</AlertTitle>}
			<RenderMessage />
		</Alert>
	);
};
export default MUIAlert;
